var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.$style.portalPopupOverlay,style:(_vm.popupStyle),on:{"click":_vm.onOverlayClick}},[_c('div',{ref:"relContainerRef",style:(_vm.relativeStyle)},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }